import { useEffect, useState } from 'react';
import { AgrupadorCorporacionLiquidadora } from '../../system/agrupador_corporacion_liquidadora/AgrupadorCorporacionLiquidadoraSystem';
import TimeTaxSupportSystemClient from '../../system';

export interface UseAgrupadorCorporacionLiquidadoraListResult {
  data: AgrupadorCorporacionLiquidadora[];
  loading: boolean;
  error: boolean;
  reload: () => Promise<void>;
}

export default function useAgrupadorCorporacionLiquidadoraList(system: TimeTaxSupportSystemClient): UseAgrupadorCorporacionLiquidadoraListResult {
  const [data, setData] = useState<AgrupadorCorporacionLiquidadora[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const load = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await system.getAgrupadorCorporacionLiquidadoraSystem().list();
      setData(response.data);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (system) {
      load();
    }
  }, [system]);

  return {
    data,
    loading,
    error,
    reload: load,
  };
}
